
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/home-furniture",
      function () {
        return require("private-next-pages/products/home-furniture/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/home-furniture"])
      });
    }
  